import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import {
	AddCompanyRequestStatus,
	AddCompanyRequestStatusEvent,
} from 'src/app/ui/add-company/add-company-main-tab.component';
import { MatDivider } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

export enum AddCompanyConfirmationType {
	createCompany = 'createCompany',
	addToMyList = 'addToMyList',
}

@Component({
	selector: 'app-add-company-confirmation',
	templateUrl: './add-company-confirmation.component.html',
	styleUrls: [
		'./add-company-confirmation.component.css',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [MatDivider, MatProgressSpinner, MatButton],
})
export class AddCompanyConfirmationComponent implements OnInit {
	@Input() email!: string;
	@Input() companyName!: string;
	@Input()
	addCompanyRequestStatusEvents!: Observable<AddCompanyRequestStatusEvent>;
	@Input() confirmationType!: AddCompanyConfirmationType;
	showLoading = false;
	showSuccess = false;
	showFailure = false;
	alreadyTakenUsernames = '';

	constructor(
		private readonly router: Router,
		private readonly navHistory: NavigationHistoryService
	) {}

	ngOnInit(): void {
		this.addCompanyRequestStatusEvents.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			switch (event.status) {
				case AddCompanyRequestStatus.loading:
					this.showLoading = true;
					break;
				case AddCompanyRequestStatus.success:
					this.showSuccess = true;
					if (
						event.data?.apiUsersNotAdded &&
						event.data?.apiUsersNotAdded.length > 0
					) {
						this.alreadyTakenUsernames = Array.from(
							event.data.apiUsersNotAdded?.values() ?? []
						).join(', ');
					}
					break;
				case AddCompanyRequestStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	onAddAnotherCompanyClicked(): void {
		this.router.navigateByUrl('/add-company');
	}

	onReturnToPublicDirectoryClicked(): void {
		this.navHistory.navigateBack();
	}
}
